import "./Content.css";

export function Content({ children }: { children: React.ReactNode }) {
  return <div className="content">{children}</div>;
}
